export default __webpack_public_path__ + "static/media/WakingUp.81379f29.png";